export default class TariffRenderer {

    static formatNumber(input, useFixed = false) {
        let number = parseFloat(input);
        if (isNaN(number)) return input;

        let formattedNumber = useFixed ? number.toFixed(2) : number.toFixed(0);
        formattedNumber = formattedNumber.replace('.', ',');
        formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        return formattedNumber;
    }

    static getTariffFlags(tariffType) {
        return {
            currentFriendsAndFamilyTariff: tariffType === '-friends',
            currentDynamicTariff: tariffType === '-dynamic',
            currentStromsteuerTariff: tariffType === '-stromsteuer',
            currentLightTariff: tariffType === '-light',
            currentFreundeTariff: tariffType === '-freunde',
            currentGemeindestromTariff: tariffType === '-gemeindestrom',
            currentSonnenregionErzgebirgeTariff: tariffType === '-erzgebirge',
            currentDefaultTariff: tariffType === '-default',
            currentSuccessorTariff: tariffType === '-successor',
            currentFuuursorglichHomeTariff: tariffType === '-fuuursorglichhome',
        };
    }

    static getYearsByFlags(flags) {
        if (flags.currentFreundeTariff) return '5';
        if (flags.currentGemeindestromTariff) return '6';
        if (flags.currentSonnenregionErzgebirgeTariff) return '20';
        return '10';
    }

    static renderStep4TableTotalPrice(args) {
        const {
            idPrefix = '',
            tariff_id,
            consumption,
            runtimeInMonth,
            baseFeeGross,
            totalExpensesCostPerYear,
            upto1000kwh,
            totalExpensesCostPerKwHInEuro,
            totalChargesPerKwHInEuro,
            totalCostPerMonth,
            energyPriceNet,
            energyPriceGross,
            energiepreis,
            unsereGebuhr,
            gruuunBonus,
            energiepreisPlusBonus,
            averageAllInPrice,
            averageAuctionPrice,
            bonusPercentage,
            flags,
            forceSuccessorTariffOverview = false
        } = args;

        const f = flags;
        const formatNumber = this.formatNumber.bind(this);

        let tableTopHtml;
        let tableBottomHtml;
        let runtimeInMonthText = f.currentDynamicTariff ? `1 Monat` : `${runtimeInMonth} Monate`;
        let unsereGebuhrTextSmall = (
            f.currentDynamicTariff ||
            f.currentLightTariff ||
            f.currentFreundeTariff ||
            f.currentGemeindestromTariff ||
            f.currentSonnenregionErzgebirgeTariff
        ) ? '' : '(10 Jahre Garantie)';

        const years = this.getYearsByFlags(f);

        if(f.currentSuccessorTariff || forceSuccessorTariffOverview) {
            tableTopHtml = `<table class="bordered -top-table">
                  <tr>
                      <td>Energiepreis netto <br> <small>(inkl. Bonus und ${years} Jahre Garantie)</small></td>
                      <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                  </tr>
                  <tr>
                      <td>Netzentgelte, Steuern und Gebühren <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                      <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                  </tr>
                  <tr class="-red">
                      <td>Arbeitspreis gesamt</td>
                      <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                  </tr>
              </table>`

            tableBottomHtml = `<div class="total">
                  <table>
                      <tr>
                          <td>
                              <h4>Du zahlst monatlich insgesamt</h4>
                          </td>
                          <td>
                              <div class="price">${formatNumber(((consumption * energyPriceGross) / 12 + baseFeeGross), true)} €</div>
                          </td>
                      </tr>
                  </table>
              </div>`;
        } else if(f.currentFuuursorglichHomeTariff) {
            tableTopHtml = `<table class="bordered -top-table">
                  <tr>
                      <td>Energiepreis netto <br> <small>(inkl. Bonus und ${years} Jahre Garantie)</small></td>
                      <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                  </tr>
                  <tr>
                      <td>Netzentgelte, Steuern und Gebühren <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                      <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                  </tr>
                  <tr class="-red">
                      <td>Arbeitspreis gesamt</td>
                      <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                  </tr>
              </table>`

            tableBottomHtml = `<div class="total">
                  <table>
                      <tr>
                          <td>
                              <h4>Du zahlst monatlich insgesamt</h4>
                          </td>
                          <td>
                              <div class="price">${formatNumber(totalCostPerMonth, true)} €</div>
                          </td>
                      </tr>
                  </table>
              </div>`;
        } else if (f.currentDynamicTariff) {
            tableTopHtml = `<table class="bordered -top-table">
                  <tr>
                      <td>Energiepreis netto <br> <small>(stundenaktuell EPEX Börsenpreis)</small></td>
                      <td><b>Dynamischer Preis</b></td>
                  </tr>
                  <tr>
                      <td>Weitere Preisbestandteile <br> <small>(Umlagen, Netzentgelte, Steuern, Gebühren)</small></td>
                      <td><b>${formatNumber(averageAllInPrice - averageAuctionPrice, true)}  ct</b> / kWh</td>
                  </tr>
                  <tr class="-red">
                      <td>Durchschnittlicher Arbeitspreis (brutto) des letzten Kalendermonats</td>
                      <td><b>${formatNumber(averageAllInPrice, true)} ct</b> / kWh</td>
                  </tr>
              </table>`

            tableBottomHtml = `<div class="total">
                  <table>
                      <tr>
                          <td>
                              <h4>Rechnerischer monatlicher Betrag</h4>
                          </td>
                          <td>
                              <div class="price">${formatNumber(((consumption * (averageAllInPrice / 100)) / 12 + baseFeeGross), true)} €</div>
                          </td>
                      </tr>
                  </table>
              </div>`;
        } else if (f.currentStromsteuerTariff) {
            tableTopHtml = `<table class="bordered -top-table">
                  <tr>
                      <td>Energiepreis netto <br> <small>(Regulärer Preis)</small></td>
                      <td><b>${formatNumber(energiepreis, true)} ct</b> / kWh</td>
                  </tr>
                  <tr class="-red">
                      <td>Stromsteuer-Gutschrift <br> <small>(grüüün für 10 Jahre)</small></td>
                      <td><b>${formatNumber(gruuunBonus, true)}  ct</b> / kWh</td>
                  </tr>
                  <tr>
                      <td>Energiepreis netto <br> <small>(inkl. Bonus und 10 Jahre Garantie)</small></td>
                      <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                  </tr>
                  <tr>
                      <td>Netzentgelte, Steuern und Gebühren <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                      <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                  </tr>
                  <tr class="-red">
                      <td>Arbeitspreis gesamt</td>
                      <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                  </tr>
              </table>`

            tableBottomHtml = `<div class="total">
                  <table>
                      <tr>
                          <td>
                              <h4>Du zahlst monatlich insgesamt</h4>
                          </td>
                          <td>
                              <div class="price">${formatNumber(totalCostPerMonth, true)} €</div>
                          </td>
                      </tr>
                  </table>
              </div>`;
        } else if (f.currentSonnenregionErzgebirgeTariff) {
            tableTopHtml = `<table class="bordered -top-table">
                  <tr>
                      <td>Energiepreis netto <br> <small>(${years} Jahre Garantie)</small></td>
                      <td><b>${formatNumber(energiepreis, true)} ct</b> / kWh</td>
                  </tr>
                  <tr>
                      <td>Netzentgelte, Steuern und Gebühren <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                      <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                  </tr>
                  <tr class="-red">
                      <td>Arbeitspreis gesamt</td>
                      <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                  </tr>
              </table>`

            tableBottomHtml = `<div class="total">
                  <table>
                      <tr>
                          <td>
                              <h4>Du zahlst monatlich insgesamt</h4>
                          </td>
                          <td>
                              <div class="price">${formatNumber(totalCostPerMonth, true)} €</div>
                          </td>
                      </tr>
                  </table>
              </div>`;
        } else {
            tableTopHtml = `<table class="bordered -top-table">
                  <tr>
                      <td>Energiepreis netto <br> <small>(Regulärer Preis)</small></td>
                      <td><b>${formatNumber(energiepreis, true)} ct</b> / kWh</td>
                  </tr>
                  <tr class="-red">
                      <td>${bonusPercentage}% grüüün Bonus <br> <small>(grüüün für ${years} Jahre)</small></td>
                      <td><b>${formatNumber(gruuunBonus, true)}  ct</b> / kWh</td>
                  </tr>
                  <tr>
                      <td>Energiepreis netto <br> <small>(inkl. Bonus und ${years} Jahre Garantie)</small></td>
                      <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                  </tr>
                  <tr>
                      <td>Netzentgelte, Steuern und Gebühren <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                      <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                  </tr>
                  <tr class="-red">
                      <td>Arbeitspreis gesamt</td>
                      <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                  </tr>
              </table>`

            tableBottomHtml = `<div class="total">
                  <table>
                      <tr>
                          <td>
                              <h4>Du zahlst monatlich insgesamt</h4>
                          </td>
                          <td>
                              <div class="price">${formatNumber(totalCostPerMonth, true)} €</div>
                          </td>
                      </tr>
                  </table>
              </div>`;
        }

        return `
          <div class="tariff-total-info">
              <h2>
                  Gesamtpreis
                  <a href="#${idPrefix}tooltip-tariff-price-${tariff_id}" class="tooltip-icon"></a>
              </h2>
              <table>
                  <tr>
                      <td>Jahresverbrauch</td>
                      <td><b>${formatNumber(consumption)} kWh</b></td>
                  </tr>
                  <tr>
                      <td>Mindestlaufzeit</td>
                      <td><b>${runtimeInMonthText}</b></td>
                  </tr>
              </table>
              
              <h4>Arbeitspreis <a href="#${idPrefix}tooltip-tariff-electricity-price-${tariff_id}" class="tooltip-icon"></a></h4>
              ${tableTopHtml}
              
              <h4>Grundgebühr <a href="#${idPrefix}tooltip-tariff-base-fee-${tariff_id}" class="tooltip-icon"></a></h4>
              <table>
                  <tr>
                      <td>Unsere Grundgebühr<br> <small>${unsereGebuhrTextSmall}</small></td>
                      <td><b>${formatNumber(unsereGebuhr, true)} €</b> / Monat</td>
                  </tr>
                  <tr>
                      <td>Messstellen- / Netzbetreiber <br> <small>(Darauf haben wir keinen Einfluss)</small></td>
                      <td><b>${formatNumber((baseFeeGross - unsereGebuhr), true)} €</b> / Monat</td>
                  </tr>
                  <tr class="-red">
                      <td>Grundpreis gesamt</td>
                      <td><b>${formatNumber(baseFeeGross, true)} €</b> / Monat</td>
                  </tr>
              </table>
              ${tableBottomHtml}
          </div>
        `;
    }

    // The three tooltip renderers below are mostly your original HTML,
    // only with idPrefix and flags passed in.

    static renderTooltipPrice(args) {
        const {
            idPrefix = '',
            id,
            titlePriceModal,
            textPriceModal,
            consumption,
            upto1000kwh,
            totalChargesPerKwHInEuro,
            totalExpensesCostPerKwHInEuro,
            baseFeeGross,
            totalCostPerYear,
            runtimeInMonth,
            totalCostPerMonth,
            bottomTextPriceModal,
            energyPriceNet,
            energyPriceGross,
            energiepreis,
            unsereGebuhr,
            gruuunBonus,
            energiepreisPlusBonus,
            averageAllInPrice,
            averageAuctionPrice,
            bonusPercentage,
            flags,
            forceSuccessorTariffOverview = false
        } = args;

        const f = flags;
        const formatNumber = this.formatNumber.bind(this);

        const popupId = `${idPrefix}tooltip-tariff-price-${id}`;
        let tablesHtml;

        if(f.currentSuccessorTariff || forceSuccessorTariffOverview) {
            tablesHtml = `<div class="cost-table-box">
                <table class="main-table">
                    <tr>
                        <td>Energiepreis</td>
                        <td>${formatNumber(consumption)} x ${formatNumber(energiepreisPlusBonus, true)}  ct / kWh</td>
                        <td>${formatNumber(((consumption * energiepreisPlusBonus) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Netzentgelte, Steuern, Gebühren</td>
                        <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                        <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Unsere Grundgebühr</td>
                    <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                        <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                    </tr>
                    <tr>
                        <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                        <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                        <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                    </tr>
                </table>
                <table class="pretotal-table">
                    <tr>
                        <td>Jährlicher Betrag</td>
                        <td>${formatNumber(((consumption * energyPriceGross) / 12 + baseFeeGross) * 12, true)} €</td>
                    </tr>
                </table>
            </div>
            <table class="total-table">
                <tr>
                    <td>Monatlicher Betrag:</td>
                    <td>${formatNumber(((consumption * energyPriceGross) / 12 + baseFeeGross) * 12, true)} € / ${runtimeInMonth} Monate</td>
                    <td>${formatNumber(((consumption * energyPriceGross) / 12 + baseFeeGross), true)} €</td>
                </tr>
            </table>`;
        } else if(f.currentFuuursorglichHomeTariff) {
            tablesHtml = `<div class="cost-table-box">
                <table class="main-table">
                    <tr>
                        <td>Energiepreis</td>
                        <td>${formatNumber(consumption)} x ${formatNumber(energiepreisPlusBonus, true)}  ct / kWh</td>
                        <td>${formatNumber(((consumption * energiepreisPlusBonus) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Netzentgelte, Steuern, Gebühren</td>
                        <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                        <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Unsere Grundgebühr</td>
                    <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                        <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                    </tr>
                    <tr>
                        <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                        <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                        <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                    </tr>
                </table>
                <table class="pretotal-table">
                    <tr>
                        <td>Jährlicher Betrag</td>
                        <td>${formatNumber(totalCostPerYear, true)} €</td>
                    </tr>
                </table>
            </div>
            <table class="total-table">
                <tr>
                    <td>Monatlicher Betrag:</td>
                    <td>${formatNumber(totalCostPerYear, true)} € / ${runtimeInMonth} Monate</td>
                    <td>${formatNumber(totalCostPerMonth, true)} €</td>
                </tr>
            </table>`;
        } else if (f.currentDynamicTariff) {
            tablesHtml = `<div class="cost-table-box">
                <table class="main-table">
                    <tr>
                        <td>Durchschnittlicher Arbeitspreis (brutto) des letzten Kalendermonats</td>
                        <td>${formatNumber(consumption)} x ${formatNumber(averageAllInPrice, true)}  ct / kWh</td>
                        <td>${formatNumber(((consumption * averageAllInPrice) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Unsere Grundgebühr</td>
                        <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                        <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                    </tr>
                    <tr>
                        <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                        <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                        <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                    </tr>
                </table>
                <table class="pretotal-table">
                    <tr>
                        <td>Jährlicher Betrag</td>
                        <td>${formatNumber((((consumption * averageAllInPrice) / 100) + (12 * unsereGebuhr) + (12 * (baseFeeGross - unsereGebuhr))), true)} €</td>
                    </tr>
                </table>
            </div>
            <table class="total-table">
                <tr>
                    <td>Monatlicher Betrag:</td>
                    <td>${formatNumber((((consumption * averageAllInPrice) / 100) + (12 * unsereGebuhr) + (12 * (baseFeeGross - unsereGebuhr))), true)} € / ${runtimeInMonth} Monate</td>
                    <td>${formatNumber(((((consumption * averageAllInPrice) / 100) + (12 * unsereGebuhr) + (12 * (baseFeeGross - unsereGebuhr))) / 12), true)} €</td>
                </tr>
            </table>`;
        } else if (f.currentStromsteuerTariff) {
            tablesHtml = `<div class="cost-table-box">
                <table class="main-table">
                    <tr>
                        <td>Energiepreis netto (regulär)</td>
                        <td>${formatNumber(consumption)} x ${formatNumber(energiepreis, true)}  ct / kWh</td>
                        <td>${formatNumber(((consumption * energiepreis) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Stromsteuer-Gutschrift</td>
                        <td>${formatNumber(consumption)} x ${formatNumber(gruuunBonus, true)}  ct / kWh</td>
                        <td>${formatNumber(((consumption * gruuunBonus) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Netzentgelte, Steuern, Gebühren</td>
                        <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                        <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Unsere Grundgebühr</td>
                        <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                        <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                    </tr>
                    <tr>
                        <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                        <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                        <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                    </tr>
                </table>
                <table class="pretotal-table">
                    <tr>
                        <td>Jährlicher Betrag</td>
                        <td>${formatNumber(totalCostPerYear, true)} €</td>
                    </tr>
                </table>
            </div>
            <table class="total-table">
                <tr>
                    <td>Monatlicher Betrag:</td>
                    <td>${formatNumber(totalCostPerYear, true)} € / ${runtimeInMonth} Monate</td>
                    <td>${formatNumber(totalCostPerMonth, true)} €</td>
                </tr>
            </table>`;
        } else if (f.currentSonnenregionErzgebirgeTariff) {
            tablesHtml = `<div class="cost-table-box">
                <table class="main-table">
                    <tr>
                        <td>Energiepreis netto</td>
                        <td>${formatNumber(consumption)} x ${formatNumber(energiepreis, true)}  ct / kWh</td>
                        <td>${formatNumber(((consumption * energiepreis) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Netzentgelte, Steuern, Gebühren</td>
                        <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                        <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Unsere Grundgebühr</td>
                        <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                        <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                    </tr>
                    <tr>
                        <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                        <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                        <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                    </tr>
                </table>
                <table class="pretotal-table">
                    <tr>
                        <td>Jährlicher Betrag</td>
                        <td>${formatNumber(totalCostPerYear, true)} €</td>
                    </tr>
                </table>
            </div>
            <table class="total-table">
                <tr>
                    <td>Monatlicher Betrag:</td>
                    <td>${formatNumber(totalCostPerYear, true)} € / ${runtimeInMonth} Monate</td>
                    <td>${formatNumber(totalCostPerMonth, true)} €</td>
                </tr>
            </table>`;
        } else {
            tablesHtml = `<div class="cost-table-box">
                <table class="main-table">
                    <tr>
                        <td>Energiepreis netto (regulär)</td>
                        <td>${formatNumber(consumption)} x ${formatNumber(energiepreis, true)}  ct / kWh</td>
                        <td>${formatNumber(((consumption * energiepreis) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>${bonusPercentage}% grüüün Bonus</td>
                        <td>${formatNumber(consumption)} x ${formatNumber(gruuunBonus, true)}  ct / kWh</td>
                        <td>${formatNumber(((consumption * gruuunBonus) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Netzentgelte, Steuern, Gebühren</td>
                        <td>${formatNumber(consumption)} x ${formatNumber((energyPriceGross * 100) - energiepreisPlusBonus, true)} ct / kWh</td>
                        <td>${formatNumber(((consumption * ((energyPriceGross * 100) - energiepreisPlusBonus)) / 100), true)} €</td>
                    </tr>
                    <tr>
                        <td>Unsere Grundgebühr</td>
                    <td>12 x ${formatNumber(unsereGebuhr, true)} €</td>
                        <td>${formatNumber((12 * unsereGebuhr), true)} €</td>
                    </tr>
                    <tr>
                        <td>Grundgebühr Netz-/ Messstellenbetreiber</td>
                        <td>12 x ${formatNumber((baseFeeGross - unsereGebuhr), true)} €</td>
                        <td>${formatNumber((12 * (baseFeeGross - unsereGebuhr)), true)} €</td>
                    </tr>
                </table>
                <table class="pretotal-table">
                    <tr>
                        <td>Jährlicher Betrag</td>
                        <td>${formatNumber(totalCostPerYear, true)} €</td>
                    </tr>
                </table>
            </div>
            <table class="total-table">
                <tr>
                    <td>Monatlicher Betrag:</td>
                    <td>${formatNumber(totalCostPerYear, true)} € / ${runtimeInMonth} Monate</td>
                    <td>${formatNumber(totalCostPerMonth, true)} €</td>
                </tr>
            </table>`;
        }

        return `
            <div class="tooltip-popup -bigger" id="${popupId}">
                <div class="modal-overlay"></div>
                <div class="modal-box scroll-container">
                    <div class="modal-content">
                        <div class="close-button"></div>
                        <h3>${titlePriceModal}</h3>
                        ${textPriceModal}
                        <h4>Verbrauchskostenschätzung <span style="color: #B5AAAA;">bei ${formatNumber(consumption)} kWh / Jahr</span></h4>
                        ${tablesHtml}
                        <div class="hint -right">${bottomTextPriceModal}</div>
                    </div>
                </div>
            </div>
        `;
    }

    static renderTooltipBaseFee(args) {
        const {
            idPrefix = '',
            id,
            titleBaseFeeModal,
            baseFeeGross,
            bottomTextBaseFeeModal,
            textBaseFeeModal,
            unsereGebuhr,
            flags,
            forceSuccessorTariffOverview = false
        } = args;

        const f = flags;
        const formatNumber = this.formatNumber.bind(this);

        const unsereGebuhrTextSmall = (
            f.currentDynamicTariff ||
            f.currentLightTariff ||
            f.currentFreundeTariff ||
            f.currentGemeindestromTariff ||
            f.currentSonnenregionErzgebirgeTariff ||
            f.currentSuccessorTariff ||
            f.currentFuuursorglichHomeTariff ||
            forceSuccessorTariffOverview
        ) ? `` : `(10 Jahre Garantie)`;

        let messstellenTextSmall = (
            f.currentSuccessorTariff ||
            f.currentFuuursorglichHomeTariff ||
            forceSuccessorTariffOverview
        ) ? `` : `(Darauf haben wir keinen Einfluss)`;

        return `
            <div class="tooltip-popup -bigger" id="${idPrefix}tooltip-tariff-base-fee-${id}">
                <div class="modal-overlay"></div>
                <div class="modal-box scroll-container">
                    <div class="modal-content">
                        <div class="close-button"></div>
                        <h3>${titleBaseFeeModal}</h3>
                        <div class="flex-box">
                            <div class="cost-table-min-box">
                                <div class="cost-table-min">
                                    <table class="main-table">
                                        <tr>
                                            <td>Unsere Grundgebühr <small>${unsereGebuhrTextSmall}</small></td>
                                            <td><b>${formatNumber(unsereGebuhr, true)} €</b> / Monat</td>
                                        </tr>
                                        <tr>
                                            <td>Grundgebühr Netz-/ Messstellenbetreiber <small>${messstellenTextSmall}</small></td>
                                            <td><b>${formatNumber((baseFeeGross - unsereGebuhr), true)} € </b>/ Monat</td>
                                        </tr>
                                    </table>
                                    <table class="pretotal-table">
                                        <tr>
                                            <td>Grundpreis (brutto)</td>
                                            <td><b>${formatNumber(baseFeeGross, true)} €</b> / Monat</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="right-text">
                                ${textBaseFeeModal}
                            </div>
                        </div>
                        <div class="hint -min-margin">${bottomTextBaseFeeModal}</div>
                    </div>
                </div>
            </div>
        `;
    }

    static renderTooltipElectricityPrice(args) {
        const {
            idPrefix = '',
            id,
            titleElectricityPriceModal,
            textElectricityPriceModal,
            bottomTextElectricityPriceModal,
            energyPriceGross,
            energiepreis,
            gruuunBonus,
            energiepreisPlusBonus,
            averageAllInPrice,
            averageAuctionPrice,
            bonusPercentage,
            flags,
            forceSuccessorTariffOverview = false
        } = args;

        const f = flags;
        const formatNumber = this.formatNumber.bind(this);
        const years = this.getYearsByFlags(f);

        let tableElectricity;

        if(f.currentSuccessorTariff || forceSuccessorTariffOverview || f.currentFuuursorglichHomeTariff) {
            tableElectricity = `<div class="electricity-table-box">
                <div class="electricity-table">
                    <table class="main-table">
                        <tr><th colspan="2">inkl. Bonus und ${years} Jahre Garantie</th></tr>
                        <tr>
                            <td>Energiepreis netto</td>
                            <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-total-table">
                    <table>
                        <tr><th colspan="2">Netzentgelte, Steuern, Gebühren</th></tr>
                        <tr>
                            <td>für jede kWh</td>
                            <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-table">
                    <table class="main-table">
                        <tr>
                            <td>Arbeitspreis gesamt</td>
                            <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="hint -min-margin">${bottomTextElectricityPriceModal}</div>
            </div>`;

        } else if (f.currentDynamicTariff) {
            tableElectricity = `<div class="electricity-table-box">
                <div class="electricity-table">
                    <table class="main-table">
                        <tr><th colspan="2">Regulärer Preis</th></tr>
                        <tr>
                            <td>Energiepreis netto</td>
                            <td><b>dynamischer EPEX Preis</b></td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-total-table">
                    <table>
                        <tr><th colspan="2">Netzentgelte, Steuern, Gebühren, Umlagen</th></tr>
                        <tr>
                            <td>für jede kWh</td>
                            <td><b>${formatNumber(averageAllInPrice - averageAuctionPrice, true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-table">
                    <table class="main-table">
                        <tr>
                            <td>Durchschnittlicher Arbeitspreis des letzten Kalendermonats</td>
                            <td><b>${formatNumber(averageAllInPrice, true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="hint -min-margin">${bottomTextElectricityPriceModal}</div>
            </div>`;
        } else if (f.currentStromsteuerTariff) {
            tableElectricity = `<div class="electricity-table-box">
                <div class="electricity-table">
                    <table class="main-table">
                        <tr><th colspan="2">Regulärer Preis</th></tr>
                        <tr>
                            <td>Energiepreis netto</td>
                            <td><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-total-table">
                    <table>
                        <tr><th colspan="2">grüüün für 10 Jahre</th></tr>
                        <tr>
                            <td>Stromsteuer-Gutschrift</td>
                            <td><b>${formatNumber(gruuunBonus, true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-table">
                    <table class="main-table">
                        <tr><th colspan="2">inkl. Gutschrift und 10 Jahre Garantie</th></tr>
                        <tr>
                            <td>Energiepreis netto</td>
                            <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-total-table">
                    <table>
                        <tr><th colspan="2">Netzentgelte, Steuern, Gebühren</th></tr>
                        <tr>
                            <td>für jede kWh</td>
                            <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-table">
                    <table class="main-table">
                        <tr>
                            <td>Arbeitspreis gesamt</td>
                            <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="hint -min-margin">${bottomTextElectricityPriceModal}</div>
            </div>`;
        } else if (f.currentSonnenregionErzgebirgeTariff) {
            tableElectricity = `<div class="electricity-table-box">
                <div class="electricity-table">
                    <table class="main-table">
                        <tr>
                            <th colspan="2">Regulärer Preis</th>
                        </tr>
                        <tr>
                            <td>Energiepreis netto</td>
                            <td><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-total-table">
                    <table>
                        <tr>
                            <th colspan="2">Netzentgelte, Steuern, Gebühren</th>
                        </tr>
                        <tr>
                            <td>für jede kWh</td>
                            <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-table">
                    <table class="main-table">
                        <tr>
                            <td>Arbeitspreis gesamt</td>
                            <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="hint -min-margin">${bottomTextElectricityPriceModal}</div>
            </div>`;
        } else {
            tableElectricity = `<div class="electricity-table-box">
                <div class="electricity-table">
                    <table class="main-table">
                        <tr><th colspan="2">Regulärer Preis</th></tr>
                        <tr>
                            <td>Energiepreis netto</td>
                            <td><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-total-table">
                    <table>
                        <tr><th colspan="2">grüüün für ${years} Jahre</th></tr>
                        <tr>
                            <td>${bonusPercentage}% grüüün Bonus</td>
                            <td><b>${formatNumber(gruuunBonus, true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-table">
                    <table class="main-table">
                        <tr><th colspan="2">inkl. Bonus und ${years} Jahre Garantie</th></tr>
                        <tr>
                            <td>Energiepreis netto</td>
                            <td><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-total-table">
                    <table>
                        <tr><th colspan="2">Netzentgelte, Steuern, Gebühren</th></tr>
                        <tr>
                            <td>für jede kWh</td>
                            <td><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="electricity-table">
                    <table class="main-table">
                        <tr>
                            <td>Arbeitspreis gesamt</td>
                            <td><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</td>
                        </tr>
                    </table>
                </div>
                <div class="hint -min-margin">${bottomTextElectricityPriceModal}</div>
            </div>`;
        }

        return `
            <div class="tooltip-popup -bigger" id="${idPrefix}tooltip-tariff-electricity-price-${id}">
                <div class="modal-overlay"></div>
                <div class="modal-box scroll-container">
                    <div class="modal-content">
                        <div class="close-button"></div>
                        <h3>${titleElectricityPriceModal}</h3>
                        <div class="flex-box">
                            ${tableElectricity}
                            <div class="right-text">
                                ${textElectricityPriceModal}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    static renderTooltipTariffInfo({ idPrefix = '', id, nameExtern, contentTariffDetailsModal }) {
        return `
            <div class="tooltip-popup -bigger" id="${idPrefix}tooltip-tariff-info-${id}">
                <div class="modal-overlay"></div>
                <div class="modal-box scroll-container">
                    <div class="modal-content">
                        <div class="close-button"></div>
                        <h3 class="tariff-title">Tarifdetails <span style="color: #b5aaaa">${nameExtern}</span></h3>
                        ${contentTariffDetailsModal}
                    </div>
                </div>
            </div>
        `;
    }

    static renderMainTariffHtml(args) {
        const {
            idPrefix = '',
            id,
            classBadge,
            nameExtern,
            totalCostPerMonth,
            runtimeInMonth,
            energyPriceGross,
            energiepreis,
            unsereGebuhr,
            baseFeeGross,
            gruuunBonus,
            energiepreisPlusBonus,
            averageAllInPrice,
            averageAuctionPrice,
            consumption,
            bonusPercentage,
            umzugBenefits = '',
            flags,
            showChooseButton = true,
            chooseButtonLabel = 'Tarif buchen',
            chooseButtonClass = '-new',

            fakeButtonText = '',

            monthlyDiff = null,
            yearlyDiff = null,
            forceBadgeText = '',
            forceSuccessorTariffOverview = false,
            showDescription = false
        } = args;

        const f = flags;
        const formatNumber = this.formatNumber.bind(this);

        let topBox;
        let priceBox;
        let subtitle;

        let unsereGebuhrTextSmall = (
            f.currentDynamicTariff ||
            f.currentLightTariff ||
            f.currentFreundeTariff ||
            f.currentGemeindestromTariff ||
            f.currentSonnenregionErzgebirgeTariff ||
            f.currentSuccessorTariff ||
            f.currentFuuursorglichHomeTariff ||
            forceSuccessorTariffOverview
        ) ? `` : `(10 Jahre Garantie)`;

        let messstellenTextSmall = (
            f.currentSuccessorTariff ||
            f.currentFuuursorglichHomeTariff ||
            forceSuccessorTariffOverview
        ) ? `` : `(Darauf haben wir keinen Einfluss)`;

        const years = this.getYearsByFlags(f);

        // const monthlyDiffHtml = (
        //     typeof monthlyDiff === 'number' && Number.isFinite(monthlyDiff)
        // ) ? `
        //     <div class="month-saving">
        //             ${monthlyDiff < 0
        //     ? `Du sparst ${formatNumber(Math.abs(monthlyDiff), true)} € pro Monat`
        //     : `Mehrkosten ${formatNumber(monthlyDiff, true)} € pro Monat`
        //         }
        //     </div>
        // ` : '';

        const monthlyDiffHtml = (
            typeof monthlyDiff === 'number' && Number.isFinite(monthlyDiff)
        ) ? `
            <div class="month-saving">Du sparst ${formatNumber(Math.abs(monthlyDiff), true)} € pro Monat</div>
        ` : '';

        let computedSecondBadgeText = '';

        if (yearlyDiff !== null && yearlyDiff !== undefined) {
            const yd = Number(yearlyDiff);

            if (Number.isFinite(yd)) {
                const yearlyDiffRounded = Math.round(yd);

                // computedSecondBadgeText =
                //     `<b>${formatNumber(Math.abs(yearlyDiffRounded), false)}€</b><br>` +
                //     `pro Jahr<br>` +
                //     `<small>${yearlyDiffRounded < 0 ? 'sparen' : 'mehr zahlen'}</small>`;

                computedSecondBadgeText =
                    `<b>${formatNumber(Math.abs(yearlyDiffRounded), false)}€</b><br>` +
                    `pro Jahr<br>` +
                    `<small>sparen</small>`;
            }
        }

        const secondBadgeHtml = computedSecondBadgeText
            ? `<div class="badge-second"><span>${computedSecondBadgeText}</span></div>`
            : '';

        if(f.currentSuccessorTariff || forceSuccessorTariffOverview) {
            topBox = `<div class="badge">${forceBadgeText ? forceBadgeText : `${bonusPercentage}% geschenkt!`}</div>
                ${secondBadgeHtml}
                <div class="top-box">
                    <h4 class="tariff-title">${nameExtern}</h4>
                    <div class="price"><span>${formatNumber(((consumption * energyPriceGross) / 12 + baseFeeGross), true)} €</span> / Monat <a href="#${idPrefix}tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                    ${monthlyDiffHtml}
                    <div class="under-price-text">${runtimeInMonth}  Monate Mindestlaufzeit, danach monatlich kündbar</div>
                </div>`;
            priceBox = `<div class="info-box">
                <div class="info-title">Arbeitspreis <a href="#${idPrefix}tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                <div class="item">
                    <div class="left-part">Energiepreis netto <small>(inkl. Bonus und ${years} Jahre Garantie)</small></div>
                    <div class="right-part"><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</div>
                </div>
                <div class="item">
                    <div class="left-part">Netzentgelte, Steuern, Gebühren</div>
                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                </div>
                <div class="item -red">
                    <div class="left-part">Arbeitspreis gesamt</div>
                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                </div>
            </div>`;
            subtitle = `So setzt sich Dein Abschlag zusammen:`;
        } else if(f.currentFuuursorglichHomeTariff) {
            topBox = `<div class="badge">${forceBadgeText ? forceBadgeText : `${bonusPercentage}% geschenkt!`}</div>
                ${secondBadgeHtml}
                <div class="top-box">
                    <h4 class="tariff-title">${nameExtern}</h4>
                    <div class="price"><span>${formatNumber(totalCostPerMonth, true)} €</span> / Monat <a href="#${idPrefix}tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                    ${monthlyDiffHtml}
                    <div class="under-price-text">${runtimeInMonth} Monate Mindestlaufzeit, danach monatlich kündbar</div>
                </div>`;
            priceBox = `<div class="info-box">
                <div class="info-title">Arbeitspreis <a href="#${idPrefix}tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                <div class="item">
                    <div class="left-part">Energiepreis netto <small>(inkl. Bonus und ${years} Jahre Garantie)</small></div>
                    <div class="right-part"><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</div>
                </div>
                <div class="item">
                    <div class="left-part">Netzentgelte, Steuern, Gebühren</div>
                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                </div>
                <div class="item -red">
                    <div class="left-part">Arbeitspreis gesamt</div>
                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                </div>
            </div>`;
            subtitle = `So setzt sich Dein Abschlag zusammen:`;
        } else if (f.currentDynamicTariff) {
            topBox = `<div class="badge">${forceBadgeText ? forceBadgeText : `Dynamischer Tarif`}</div>
                ${secondBadgeHtml}
                <div class="top-box">
                    <h4 class="tariff-title">${nameExtern}</h4>
                    <div class="price"><span>${formatNumber(((consumption * (averageAllInPrice / 100)) / 12 + baseFeeGross), true)} €</span> / Monat <a href="#${idPrefix}tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                    ${monthlyDiffHtml}
                    <div class="under-price-text">Monatlich kündbar</div>
                </div>`;
            priceBox = `<div class="info-box">
                <div class="info-title">Arbeitspreis <a href="#${idPrefix}tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                <div class="item">
                    <div class="left-part">Energiepreis netto <small>(stundenaktuell EPEX Börsenpreis)</small></div>
                    <div class="right-part">Dynamischer Preis</div>
                </div>
                <div class="item">
                    <div class="left-part">Weitere Preisbestandteile <small>(Umlagen, Netzentgelte, Steuern, Gebühren)</small></div>
                    <div class="right-part"><b>${formatNumber(averageAllInPrice - averageAuctionPrice, true)}  ct</b> / kWh</div>
                </div>
                <div class="item -red">
                    <div class="left-part">Durchschnittlicher Arbeitspreis (brutto) des letzten Kalendermonats</div>
                    <div class="right-part"><b>${formatNumber(averageAllInPrice, true)} ct</b> / kWh</div>
                </div>
            </div>`;
            subtitle = `So setzt sich Dein Preis zusammen:`;
        } else if (f.currentStromsteuerTariff) {
            topBox = `<div class="badge">${forceBadgeText ? forceBadgeText : `Stromsteuer geschenkt`}</div>
                ${secondBadgeHtml}
                <div class="top-box">
                    <h4 class="tariff-title">${nameExtern}</h4>
                    <div class="price"><span>${formatNumber(totalCostPerMonth, true)} €</span> / Monat <a href="#${idPrefix}tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                    ${monthlyDiffHtml}
                    <div class="under-price-text">${runtimeInMonth} Monate Mindestlaufzeit, anschl. monatlich kündbar</div>
                </div>`;
            priceBox = `<div class="info-box">
                <div class="info-title">Arbeitspreis <a href="#${idPrefix}tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                <div class="item">
                    <div class="left-part">Energiepreis netto <small>(Regulärer Preis)</small></div>
                    <div class="right-part"><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</div>
                </div>
                <div class="item -red">
                    <div class="left-part">Stromsteuer-Gutschrift <small>(grüüün für 10 Jahre)</small></div>
                    <div class="right-part"><b>${formatNumber(gruuunBonus, true)}  ct</b> / kWh</div>
                </div>
                <div class="item">
                    <div class="left-part">Energiepreis netto <small>(inkl. Bonus und 10 Jahre Garantie)</small></div>
                    <div class="right-part"><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</div>
                </div>
                <div class="item">
                    <div class="left-part">Netzentgelte, Steuern, Gebühren <small>(Darauf haben wir keinen Einfluss)</small></div>
                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                </div>
                <div class="item -red">
                    <div class="left-part">Arbeitspreis gesamt</div>
                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                </div>
            </div>`;
            subtitle = `So setzt sich Dein Abschlag zusammen:`;
        } else if (f.currentSonnenregionErzgebirgeTariff) {
            topBox = `<div class="badge">${forceBadgeText ? forceBadgeText : `Beste Wahl`}</div>
                ${secondBadgeHtml}
                <div class="top-box">
                    <h4 class="tariff-title">${nameExtern}</h4>
                    <div class="price"><span>${formatNumber(totalCostPerMonth, true)} €</span> / Monat <a href="#${idPrefix}tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                    ${monthlyDiffHtml}
                    <div class="under-price-text">${runtimeInMonth} Monate Mindestlaufzeit, anschl. monatlich kündbar</div>
                </div>          `;

            priceBox = `<div class="info-box">
                <div class="info-title">Arbeitspreis <a href="#${idPrefix}tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                <div class="item">
                    <div class="left-part">Energiepreis netto <small>(${years} Jahre Garantie)</small></div>
                    <div class="right-part"><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</div>
                </div>
                <div class="item">
                    <div class="left-part">Netzentgelte, Steuern, Gebühren <small>(Darauf haben wir keinen Einfluss)</small></div>
                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                </div>
                <div class="item -red">
                    <div class="left-part">Arbeitspreis (brutto) gesamt</div>
                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                </div>
            </div>`;

            subtitle = `So setzt sich Dein Abschlag zusammen:`;
        }
        else {
            topBox = `<div class="badge">${forceBadgeText ? forceBadgeText : `${bonusPercentage}% geschenkt!`}</div>
                ${secondBadgeHtml}
                <div class="top-box">
                    <h4 class="tariff-title">${nameExtern}</h4>
                    <div class="price"><span>${formatNumber(totalCostPerMonth, true)} €</span> / Monat <a href="#${idPrefix}tooltip-tariff-price-${id}" class="tooltip-icon"></a></div>
                    ${monthlyDiffHtml}
                    <div class="under-price-text">${runtimeInMonth} Monate Mindestlaufzeit, anschl. monatlich kündbar</div>
                </div>`;
            priceBox = `<div class="info-box">
                <div class="info-title">Arbeitspreis <a href="#${idPrefix}tooltip-tariff-electricity-price-${id}" class="tooltip-icon"></a></div>
                <div class="item">
                    <div class="left-part">Energiepreis netto <small>(Regulärer Preis)</small></div>
                    <div class="right-part"><b>${formatNumber(energiepreis, true)}  ct</b> / kWh</div>
                </div>
                <div class="item -red">
                    <div class="left-part">${bonusPercentage}% grüüün Bonus <small>(grüüün für ${years} Jahre)</small></div>
                    <div class="right-part"><b>${formatNumber(gruuunBonus, true)}  ct</b> / kWh</div>
                </div>
                <div class="item">
                    <div class="left-part">Energiepreis netto <small>(inkl. Bonus und ${years} Jahre Garantie)</small></div>
                    <div class="right-part"><b>${formatNumber(energiepreisPlusBonus, true)}  ct</b> / kWh</div>
                </div>
                <div class="item">
                    <div class="left-part">Netzentgelte, Steuern, Gebühren <small>(Darauf haben wir keinen Einfluss)</small></div>
                    <div class="right-part"><b>${formatNumber(((energyPriceGross * 100) - energiepreisPlusBonus), true)} ct</b> / kWh</div>
                </div>
                <div class="item -red">
                    <div class="left-part">Arbeitspreis gesamt</div>
                    <div class="right-part"><b>${formatNumber((energyPriceGross * 100), true)} ct</b> / kWh</div>
                </div>
            </div>`;
            subtitle = `So setzt sich Dein Abschlag zusammen:`;
        }

        const chooseButtonHtml = showChooseButton ? `
            <div class="button-box">
                <button class="btn btn-cta arrow-right ${chooseButtonClass}" id="choose-tariff-${id}">
                    ${chooseButtonLabel}
                </button>
            </div>
        ` : (fakeButtonText ? `
            <div class="button-box">
                <div class="btn btn-cta arrow-right -new">${fakeButtonText}</div>
            </div>
        ` : '');

        return `<div class="tariff-info-box">
            <div class="tariff-info" data-tariff="${id}">
                <div class="top-wrapper">
                    <div class="top-and-badge">
                        ${topBox}
                    </div>
                    ${chooseButtonHtml}
                </div>
                <div class="grey-box">
                    <div class="text-2 bold">${subtitle}</div>
                    <div class="info-boxes">
                        ${priceBox}
                        <div class="info-box">
                            <div class="info-title">Grundgebühr <a href="#${idPrefix}tooltip-tariff-base-fee-${id}" class="tooltip-icon"></a></div>
                            <div class="item">
                                <div class="left-part">Unsere Gebühr <small>${unsereGebuhrTextSmall}</small></div>
                                <div class="right-part"><b>${this.formatNumber(unsereGebuhr, true)} €</b> / Monat</div>
                            </div>
                            <div class="item">
                                <div class="left-part">Messstellen-/ Netzbetreiber <small>${messstellenTextSmall}</small></div>
                                <div class="right-part"><b>${this.formatNumber((baseFeeGross - unsereGebuhr), true)} €</b> / Monat</div>
                            </div>
                            <div class="item -red">
                                <div class="left-part">Grundpreis gesamt</div>
                                <div class="right-part"><b>${this.formatNumber(baseFeeGross, true)} €</b> / Monat</div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom-link">
                        <a href="#${idPrefix}tooltip-tariff-info-${id}" class="btn-link-primary arrow-right tooltip-link">Tarifdetails</a>
                    </div>
                </div>
            </div>
            ${umzugBenefits && showDescription ? `<div class="tarif-description text-3">${umzugBenefits}</div>` : ``}
        </div>`;
    }

    static buildTariffBundle(context) {
        const {
            idPrefix = '',
            tariffInfo,
            responseData,
            consumption,
            fakeButtonText = '',
            monthlyDiff = null,
            yearlyDiff = null,
            forceBadgeText = '',
            forceSuccessorTariffOverview = false,
            showDescription = false
        } = context;

        const { tariff, priceCalculation } = tariffInfo;
        const { nameExtern, energyPriceGross, energyPriceNet, baseFeeGross, runtimeInMonth } = tariff;
        const { totalCostPerMonth, totalCostPerYear } = priceCalculation;

        const ru = responseData;

        const flags = this.getTariffFlags(ru.tariffType);

        const averageAuctionPrice = ru.averageAuctionPrice ? parseFloat(ru.averageAuctionPrice) : 0;
        const averageAllInPrice = ru.averageAllInPrice ? parseFloat(ru.averageAllInPrice) : 0;

        const tooltipPriceHtml = this.renderTooltipPrice({
            idPrefix,
            id: tariff.id,
            titlePriceModal: ru.titlePriceModal,
            textPriceModal: ru.textPriceModal,
            consumption,
            upto1000kwh: ru.upto1000kwh,
            baseFeeGross,
            totalCostPerYear,
            runtimeInMonth,
            totalCostPerMonth,
            bottomTextPriceModal: ru.bottomTextPriceModal,
            energyPriceNet,
            energyPriceGross,
            energiepreis: ru.energiepreis,
            unsereGebuhr: ru.unsereGebuhr,
            gruuunBonus: ru.gruuunBonus,
            energiepreisPlusBonus: ru.energiepreisPlusBonus,
            averageAllInPrice,
            averageAuctionPrice,
            bonusPercentage: ru.bonusPercentage,
            flags,
            forceSuccessorTariffOverview
        });

        const tooltipBaseFeeHtml = this.renderTooltipBaseFee({
            idPrefix,
            id: tariff.id,
            titleBaseFeeModal: ru.titleBaseFeeModal,
            baseFeeGross,
            bottomTextBaseFeeModal: ru.bottomTextBaseFeeModal,
            textBaseFeeModal: ru.textBaseFeeModal,
            unsereGebuhr: ru.unsereGebuhr,
            flags,
            forceSuccessorTariffOverview
        });

        const tooltipElectricityPriceHtml = this.renderTooltipElectricityPrice({
            idPrefix,
            id: tariff.id,
            titleElectricityPriceModal: ru.titleElectricityPriceModal,
            textElectricityPriceModal: ru.textElectricityPriceModal,
            bottomTextElectricityPriceModal: ru.bottomTextElectricityPriceModal,
            energyPriceGross,
            energiepreis: ru.energiepreis,
            gruuunBonus: ru.gruuunBonus,
            energiepreisPlusBonus: ru.energiepreisPlusBonus,
            averageAllInPrice,
            averageAuctionPrice,
            bonusPercentage: ru.bonusPercentage,
            flags,
            forceSuccessorTariffOverview
        });

        const tooltipTariffInfoHtml = this.renderTooltipTariffInfo({
            idPrefix,
            id: tariff.id,
            nameExtern,
            contentTariffDetailsModal: ru.contentTariffDetailsModal,
        });

        const step4TableTotalPrice = this.renderStep4TableTotalPrice({
            idPrefix,
            tariff_id: tariff.id,
            consumption,
            runtimeInMonth,
            baseFeeGross,
            totalExpensesCostPerYear: ru.totalExpensesCostPerYear || 0,
            upto1000kwh: ru.upto1000kwh,
            totalExpensesCostPerKwHInEuro: (ru.totalExpensesCostPerKwH || 0) / 100,
            totalChargesPerKwHInEuro: (tariffInfo.charges?.totalChargesPerKwH || 0) / 100,
            totalCostPerMonth,
            energyPriceNet,
            energyPriceGross,
            energiepreis: ru.energiepreis,
            unsereGebuhr: ru.unsereGebuhr,
            gruuunBonus: ru.gruuunBonus,
            energiepreisPlusBonus: ru.energiepreisPlusBonus,
            averageAllInPrice,
            averageAuctionPrice,
            bonusPercentage: ru.bonusPercentage,
            flags,
            forceSuccessorTariffOverview
        });

        const mainHtml = this.renderMainTariffHtml({
            idPrefix,
            id: tariff.id,
            classBadge: ru.badgeBest ? '-main' : '',
            nameExtern,
            totalCostPerMonth,
            runtimeInMonth,
            energyPriceGross,
            energiepreis: ru.energiepreis,
            unsereGebuhr: ru.unsereGebuhr,
            baseFeeGross,
            gruuunBonus: ru.gruuunBonus,
            energiepreisPlusBonus: ru.energiepreisPlusBonus,
            averageAllInPrice,
            averageAuctionPrice,
            consumption,
            bonusPercentage: ru.bonusPercentage,
            umzugBenefits: ru.umzugBenefits,
            flags,
            showChooseButton: context.showChooseButton ?? true,
            chooseButtonLabel: context.chooseButtonLabel ?? 'Tarif buchen',
            chooseButtonClass: context.chooseButtonClass ?? '-new',
            fakeButtonText,

            monthlyDiff,
            yearlyDiff,
            forceBadgeText,
            forceSuccessorTariffOverview,
            showDescription
        });

        const popupsHtml = `
            ${tooltipPriceHtml}
            ${tooltipBaseFeeHtml}
            ${tooltipElectricityPriceHtml}
            ${tooltipTariffInfoHtml}
        `;

        return {
            mainHtml,
            popupsHtml,
            step4TableTotalPrice,
            flags,
            shortDescription: ru.shortDescription,
        };
    }
}
